module.exports = "<li>\r\n    <div class=\"active\"></div>\r\n    <i [class]=\"iconSrc\"></i>\r\n    <span>{{name}}</span> \r\n</li>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/www/onetouchSuperAdmin/src/app/core/menu/menu-item/menu-item.component.html
// module id = ../../../../../src/app/core/menu/menu-item/menu-item.component.html
// module chunks = 2